const initialState = {
    pricedItems: [],
    isPricingDone: false,
};

const consignmentAddCartDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        default: {
            return { ...state };
        }
    }
};

export default consignmentAddCartDetailsReducer;
